import React from 'react';
import Grid from '@material-ui/core/Grid';
import { Link } from 'react-router-dom';
import Paper from '@material-ui/core/Paper';

import ArrowDown from '@material-ui/icons/KeyboardArrowDown';
import ArrowUp from '@material-ui/icons/KeyboardArrowUp';

import styled from 'styled-components';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreHoriz from '@material-ui/icons/MoreHoriz';
import IconButton from '@material-ui/core/IconButton';
import NewProjectDialog from '../NewProjectDialog';
import DeleteDialog from '../DeleteDialog';
import { deleteProject } from 'Actions/projectActions';
import { connect } from 'react-redux';
import axios from 'Axios';
import Tooltip from 'Tooltip';
import { Bottom, Statistics, StatisticsItem } from '../../styled/Statistics';

const ProjectName = styled.h2`
  text-transform: capitalize;
`;
const ProjectCardMore = styled.div`
  // &&& svg {
  //   color: #37474f !important;
  // }
`;
const ProjectCardHolder = styled.div`
  display: flex;
`;
const ActiveProjectCardDiv = styled.div`
  padding-right: 0 !important;
`;

class ActiveProjectCard extends React.Component {
  state = {
    showTickets: true,
    anchorEl: null,
    deleteDialog: false,
  };
  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };
  handleOpenEditDialog = () => {
    this.setState({ newProjectDialogOpen: true });
    this.handleClose();
  };
  handleCloseEditDialog = () => {
    this.setState({ newProjectDialogOpen: false });
  };
  openDeleteDialog = () => {
    this.setState({ deleteDialog: true });
  };
  closeDeleteDialog = () => {
    this.setState({ deleteDialog: false });
  };
  downloadSpecsheet = () => {
    axios({
      url: 'zip/project_spec_sheet/' + this.props.project.id,
      method: 'GET',
      responseType: 'blob', // important
    }).then(
      response => {
        if (response.data) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'SpecificationSheet.zip'); //or any other extension
          document.body.appendChild(link);
          link.click();
        }
      },
      error => {
        console.error(error);
      }
    );
  };
  renderArrow = () => {
    if (this.props.tickets && this.props.tickets.length > 0) {
      if (this.state.showTickets) {
        return <ArrowUp />;
      } else {
        return <ArrowDown />;
      }
    }
  };

  showTickets = () => {
    this.setState({ showTickets: !this.state.showTickets });
  };

  render() {
    const { anchorEl } = this.state;
    return (
      <Grid item xs={11}>
        <Paper className="project-card" xs={12}>
          <ActiveProjectCardDiv className="active-project-card">
            <Link
              className="project-card-basic-info"
              to={`/demand/project/${this.props.project.id}`}
            >
              <div className="content">
                <ProjectName className="project-card-name t-primary-18">
                  {this.props.project ? this.props.project.name : ''}
                </ProjectName>
              </div>
              <span className="stick-to-footer project-card-project-number t-secondary-14">
                <b>Project number: </b>
                {this.props.project
                  ? this.props.project.uniqueProjectNumber
                  : ''}
              </span>
            </Link>
            <ProjectCardHolder>
              <ProjectCardMore>
                <IconButton
                  aria-label="More"
                  aria-owns={anchorEl ? 'long-menu' : null}
                  aria-haspopup="true"
                  onClick={e => this.handleClick(e)}
                >
                  <MoreHoriz className="project-card-hover-more-icon" />
                </IconButton>
                <Menu
                  className="long-menu"
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={() => this.handleClose()}
                >
                  <MenuItem
                    key={0}
                    onClick={() =>
                      this.props.handleOpenShareDialog(this.props.project.id)
                    }
                  >
                    Share
                  </MenuItem>
                  <MenuItem key={1} onClick={this.handleOpenEditDialog}>
                    Edit
                  </MenuItem>
                  {/* <MenuItem key={2} onClick={this.handleClose}>
                Archive
              </MenuItem> */}
                  {/*<MenuItem key={2} onClick={()=>(this.props.deleteProject(this.props.project.id))}>*/}
                  {/*Delete*/}
                  {/*</MenuItem>*/}
                  <MenuItem key={3} onClick={this.openDeleteDialog}>
                    Remove
                  </MenuItem>
                  <MenuItem key={4} onClick={this.downloadSpecsheet}>
                    Specsheets
                  </MenuItem>
                </Menu>
              </ProjectCardMore>{' '}
              {/* {this.props.tickets && this.props.tickets.length > 0 && (
                <div
                  onClick={() => this.showTickets()}
                  className="activeProjectDetails"
                >
                  {this.renderArrow()}
                </div>
              )} */}
            </ProjectCardHolder>
          </ActiveProjectCardDiv>
          {this.state.showTickets &&
            this.props.tickets &&
            this.props.tickets.length > 0 && (
              <div className="active-project-switch">
                {this.props.tickets.map(ticket => {
                  return (
                    <Link
                      key={ticket.ticketId}
                      // to={`/demand/project/${this.props.project.id}/ticket/${
                      //   ticket.ticketId
                      // }/slips`}

                      to={`/demand/project/${this.props.project.id}/ticket/${ticket.ticketId}`}
                    >
                      <div
                        data-tip={'Search reference'}
                        data-for={'TId' + ticket.ticketId}
                      >
                        <Tooltip tooltipId={'TId' + ticket.ticketId} />
                        <span
                          className={
                            parseInt(this.props.currentTicketId) ==
                            ticket.ticketId
                              ? 'active'
                              : ''
                          }
                        >
                          {ticket.referenceName}
                        </span>
                      </div>
                    </Link>
                  );
                })}
              </div>
            )}
          <Bottom>
            <Statistics sidebar>
              {/*{this.props.newSlipsCount && (*/}
              <StatisticsItem>
                <span
                  className={
                    this.props.deletedTicket === null ||
                    (this.props.deletedTicket &&
                      !this.props.deletedTicket.hasAnyUpdatedSlipColumnOne)
                      ? 'project-card-team-members-item-circle bc-secondary u-border-none t-primary-12'
                      : 'project-card-team-members-item-circle bc-red u-border-none t-primary-12'
                  }
                >
                  {this.props.deletedTicket &&
                  this.props.deletedTicket.numberOfNewAndViewedSlips !== null
                    ? this.props.deletedTicket.numberOfNewAndViewedSlips
                    : 0}
                </span>
                <span className="u-mrg-left-2 t-primary-14">Luminaires</span>
              </StatisticsItem>
              <StatisticsItem>
                <span
                  className={
                    this.props.deletedTicket === null ||
                    (this.props.deletedTicket &&
                      !this.props.deletedTicket.hasAnyUpdatedSlipColumnTwo)
                      ? 'project-card-team-members-item-circle bc-secondary u-border-none t-primary-12'
                      : 'project-card-team-members-item-circle bc-yellow u-border-none t-primary-12'
                  }
                >
                  {this.props.deletedTicket &&
                  this.props.deletedTicket.numberOfMatchedSlips !== null
                    ? this.props.deletedTicket.numberOfMatchedSlips
                    : 0}
                </span>
                <span className="u-mrg-left-2 t-primary-14">Matches</span>
              </StatisticsItem>
              <StatisticsItem>
                <span
                  className={
                    this.props.deletedTicket === null ||
                    (this.props.deletedTicket &&
                      !this.props.deletedTicket.hasAnyUpdatedSlipColumnThree)
                      ? 'project-card-team-members-item-circle bc-secondary u-border-none t-primary-12'
                      : 'project-card-team-members-item-circle bc-green u-border-none t-primary-12'
                  }
                >
                  {this.props.deletedTicket &&
                  this.props.deletedTicket.numberOfDealedSlips !== null
                    ? this.props.deletedTicket.numberOfDealedSlips
                    : 0}
                </span>
                <span className="u-mrg-left-2 t-primary-14">Selections</span>
              </StatisticsItem>
            </Statistics>
          </Bottom>
        </Paper>
        <NewProjectDialog
          edit
          newProjectDialogOpen={this.state.newProjectDialogOpen}
          handleClose={this.handleCloseEditDialog}
          project={this.props.project}
        />
        <DeleteDialog
          element={'project'}
          doDelete={() => this.props.deleteProject(this.props.project.id)}
          handleClose={this.closeDeleteDialog}
          isOpen={this.state.deleteDialog}
        />
      </Grid>
    );
  }
}

// export default ActiveProjectCard;

const mapStateToProps = store => {
  return {
    deletedTicket: store.currentProject.data,
  };
};

const mapDispatchToProps = dispatch => ({
  deleteProject: projectId => {
    dispatch(deleteProject(projectId));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ActiveProjectCard);
